<div class="form-field__label form-field__label--external">
  @if (field?.label; as label) {
    {{ label | translateInline }}
  }
</div>
<fmnts-icon-rating
  readonly
  [rating]="rating$ | async"
  [icon]="icon"
  iconSize="1x"
  [max]="5"
></fmnts-icon-rating>
